import { type CurrentPageContextType } from '@atlassian/conversation-assistant-chat-prompt-input/current-page-as-context';

/**
 * The function determines to whether to add the current non-editing page as context in completion payloads.
 * This shows the context banner. A user can opt out by clicking the dismiss button.
 * returning undefined means don't send useCurrentBrowsingContext at all. false tells backend to explicitly not use the browserUrl as context.
 */
export const shouldUseCurrentNonEditingPageAsContext = ({
	enableBrowserContextBanner,
	shouldShowContextBanner = true,
	pageType,
}: {
	enableBrowserContextBanner?: boolean;
	shouldShowContextBanner?: boolean;
	pageType?: CurrentPageContextType['type'];
}): boolean | undefined => {
	if (!shouldShowContextBanner) {
		return false;
	}

	// Using browser context (rovo extension sidebar) return true
	if (enableBrowserContextBanner) {
		return true;
	}

	// if user is viewing a 1p atlassian page in mini modal or in product side panel return true else return undefined
	return pageType === 'current_page' ? true : undefined;
};
